module.exports = __webpack_public_path__ + "static/media/shape0_0.6ad4590b.obj";